import * as e from "react";
const t = (l) => /* @__PURE__ */ e.createElement(
  "svg",
  {
    viewBox: "0 0 32 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...l
  },
  /* @__PURE__ */ e.createElement(
    "mask",
    {
      id: "CX_svg__a",
      style: {
        maskType: "alpha"
      },
      maskUnits: "userSpaceOnUse",
      x: 0,
      y: 0,
      width: 32,
      height: 24
    },
    /* @__PURE__ */ e.createElement("path", { fill: "#fff", d: "M0 0h32v24H0z" })
  ),
  /* @__PURE__ */ e.createElement("g", { mask: "url(#CX_svg__a)", fillRule: "evenodd", clipRule: "evenodd" }, /* @__PURE__ */ e.createElement("path", { d: "M0 0h32v24H0V0z", fill: "#5EAA22" }), /* @__PURE__ */ e.createElement("path", { d: "M0 0l32 24H0V0z", fill: "#4141DB" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M6 9l-1 .732.134-1.232L4 8l1.134-.5L5 6.268 6 7l1-.732L6.866 7.5 8 8l-1.134.5L7 9.732 6 9zM4 15l-1 .732.134-1.232L2 14l1.134-.5L3 12.268 4 13l1-.732-.134 1.232L6 14l-1.134.5L5 15.732 4 15zM8 21l-1 .732.134-1.232L6 20l1.134-.5L7 18.268 8 19l1-.732-.134 1.232L10 20l-1.134.5L9 21.732 8 21zM9 11.5l-.5.366.067-.616L8 11l.567-.25-.067-.616.5.366.5-.366-.067.616L10 11l-.567.25.067.616L9 11.5z",
      fill: "#fff"
    }
  ), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M21.561 12.223c-.374-.39 2.99-1.306 3.339-2.487.462-1.029.153-1.863-1.593-2.595-1.746-.732-3.51-2.147-1.481-2.147s2.029.29 2.574 1.143c.545.853 1.723 1.036 1.748 0 0-1.766.167-2.004-1.258-3.539-1.426-1.535 3.574.63 3.16 3.262-.413 2.632-.91 1.783-.594 2.225.316.442 2.216-.93 1.979.897-.665 1.05-1.984 2.614-7.874 3.242z",
      fill: "#FECA00"
    }
  ), /* @__PURE__ */ e.createElement("path", { d: "M16 17a5 5 0 100-10 5 5 0 000 10z", fill: "#FECA00" }), /* @__PURE__ */ e.createElement(
    "path",
    {
      d: "M12.953 10.162c.567-.127 1.342 1.392 2.742.822s1.692-1.657 2.357-1.259c.665.398.752 1.357.31 1.838-.444.482-1.195.596-1.195 1.204 0 .61-.148 2.78-.435 2.151-.862-.699-.336-1.813-1.397-2.15-1.062-.338-1.706-.327-2.49-.184-.782.142.527-.392.804-.9.566-.543-.956-1.341-.696-1.522z",
      fill: "#548650"
    }
  ))
);
export {
  t as default
};
